import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/styles';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import Routes from './Routes';
import '../src/views/styles.css';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-149403293-1'); // UA-149403293-1     000000000
const browserHistory = createBrowserHistory();

// Initialize google analytics page view tracking
browserHistory.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname);
  // console.log('browserHistory:' + location.pathname)
});

export default function App() {

  useEffect(() => { // Capture path + search
    ReactGA.pageview(window.location.pathname + window.location.search);
    // console.log('useEffect:' + window.location.pathname + window.location.search)
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Router history={browserHistory}>
        <Routes />
      </Router>
    </ThemeProvider>
  );

}